import { SheetHeader, SheetTitle } from '@svenskaspelab/ui/react/sheet';
import type { ReactNode } from 'react';

import { cn } from '../utils/entry.js';

type TipsenSheetHeaderProps = {
  className?: string;
  title: string;
};

/**
 * TipsenSheet header wrapper.
 *
 * @param root0 root
 * @param root0.className optional class name to apply to the header
 * @param root0.title the title to pass down
 * @returns TipsenSheet header wrapper.
 */
export default function TipsenSheetHeader({ className, title }: TipsenSheetHeaderProps): ReactNode {
  return (
    <SheetHeader className={cn('mb-4', className)}>
      <SheetTitle>{title}</SheetTitle>
    </SheetHeader>
  );
}
